import styled from "styled-components";

export const TextFileWithButtonStyles = styled.div`
  .inputContainers {
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[4]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px;

    .addButton {
      font-weight: 600;
      padding: ${({ theme }) => theme.spacing[8]} 12.5px;

      &:hover {
        background: ${({ theme }) => theme.colors.semantic.text.strong};
        color: ${({ theme }) => theme.colors.semantic.accent.onAccent};
        border: 1px solid ${({ theme }) => theme.colors.semantic.text.strong};
      }
    }

    .valueContainer {
      padding: 5px 6px;
      display: flex;
      align-items: center;
      width: ${({ $value }) => $value && "calc(100% - 40px)"};

      .value {
        font-style: normal;
        font-weight: ${({ theme }) => theme.typography.body.b2.weight};
        font-size: ${({ theme }) => theme.typography.body.b2.size};
        line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
        color: ${({ theme }) => theme.colors.semantic.text.strong};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        opacity: ${({ $value }) => ($value ? "1" : "0.5")};
        width: 100%;
      }

      .valueTextColor {
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }
    }
  }

  .error {
    border: 1px solid ${({ theme }) => theme.colors.semantic.text.error} !important;
  }

  .errorMessage {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.caption.c1.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.error};
    margin-top: ${({ theme }) => theme.spacing[4]};
    height: 24px;
  }

  .delete:hover path {
    fill: ${({ theme }) => theme.colors.semantic.accent.onAccent};
  }

  .input {
    flex: 1 1 auto;
    border: 0;
    outline: none;
    background: transparent;
    padding: ${({ theme }) => theme.spacing[12]}
      ${({ theme }) => theme.spacing[16]};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    width: 100%;
    resize: none;
    overflow: hidden;
    min-height: 44px;
    max-height: 160px;
    overflow-y: auto;

    &::placeholder {
      color: ${({ theme }) => theme.colors.semantic.text.weak};
    }
  }

  .button {
    flex: 0 0 auto;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    border: 0;
    padding: ${({ theme }) => theme.spacing[8]}
      ${({ theme }) => theme.spacing[16]};
    margin-right: ${({ theme }) => theme.spacing[4]};
    border-radius: ${({ theme }) => theme.radius[8]};
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .inputContainer {
    position: relative;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[12]};
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing[4]};
    padding: ${({ theme }) => theme.spacing[4]};

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.semantic.accent.default};
    }
  }

  .charCounter {
    margin-top: ${({ theme }) => theme.spacing[4]};
    text-align: right;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-variant-numeric: tabular-nums;

    &.atLimit {
      color: ${({ theme }) => theme.colors.semantic.text.error};
      font-weight: ${({ theme }) => theme.typography.title.t3.weight};
    }
  }
`;
